import Splide from '@splidejs/splide-4';

import { _isOnScreen, _once } from '../../utils';

_isOnScreen(
  '.splide-hero',
  _once(() => {
    new Splide('.splide-hero', {
      type: 'fade',
      rewind: true,
      label: 'hero-slider',
      pagination: true,
      arrows: true,
      perPage: 1,
    }).mount();
  }),
);
